var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticClass:"scorm-player",attrs:{"src":`scorm/${_vm.course_id}/${_vm.executableFile}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }